import React, { useEffect, useRef, useState } from "react";
import "./Invoices.css";
import { Container, Col, Row } from "react-bootstrap";
import { GetCustomerInvoices } from "../../apis/InvoiceAPI";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";
import { filterBy } from "@progress/kendo-data-query";
import { InvoiceFilter } from "../../components/SearchFilter/InvoiceFilter";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Invoices() {
  const {user} = useSelector((state) => state.auth);
  const [invoiceData, setInvoiceData] = useState([]);
  const [visible, setVisible] = useState(9);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [isSearchedData, setIsSearchedData] = useState(false);
  const [reportTypes, setReportTypes] = useState([]);
  const [allReport, setAllReport] = useState([]);

  
  const [sortingField, setSortingField] = useState("invoice_id");
  const [sortingOrder, setSortingOrder] = useState("desc");
  
  const searchBody = useRef();
  const loadMoreData = () => {
    setVisible((prevValue) => prevValue + 9);
  };

  async function GetInvoiceData(oldlist) {
    let body = searchBody.current;
    var result = await GetCustomerInvoices(body);
    var data = result.data;
    if (oldlist.length > 0) {
      let list = JSON.parse(JSON.stringify(oldlist));
      list.push(...data);
      setInvoiceData(list);
    } else setInvoiceData(data);
    if (data.length > 0) setTotalRecord(data[0].totalRows);
  }

  const getReportList = async () => {
    var result = await GetCustomerAllReports(user.customerid);
    setAllReport(result.data.slice());
    setReportTypes(result.data.slice());
  };

  const filterData = (filter) => {
    const data = allReport.slice();
    return filterBy(data, filter);
  };

  const reportFilterChange = (e) => {
    setReportTypes(filterData(e.filter));
  };

  useEffect(() => {
    getReportList();
  }, []);

  useEffect(() => {
    if (visible < totalRecord) {
      setShowLoadMore(true);
    } else setShowLoadMore(false);
    if (visible / 9 > pageCount) setPageCount((prevValue) => prevValue + 1);
  }, [visible, totalRecord, pageCount]);

  useEffect(() => {
    if (!isSearchedData) {
      searchBody.current = {
        pageNo: pageCount + "",
        pageSize: "9",
        requestor_id: user.requestorid,
        sortingField: sortingField,
        sortingOrder: sortingOrder
      };
    } else searchBody.current.pageNo = pageCount + "";
    if (pageCount === 1) GetInvoiceData([]);
    else GetInvoiceData(invoiceData);
  }, [invoiceData, isSearchedData, pageCount, sortingField, sortingOrder]);

  const handleSearch = async (searchValue) => {
    setPageCount(1);
    searchValue === "" ? setIsSearchedData(false) : setIsSearchedData(true);
    searchBody.current = {
      order_id: searchValue,
      pageNo: "1",
      pageSize: "9",
      requestor_id: user.requestorid,
      sortingField: sortingField,
      sortingOrder: sortingOrder
    };
    if (pageCount === 1) await GetInvoiceData([]);
  };

  const handleAdvanceSearch = async (searchData) => {
    setPageCount(1);
    setIsSearchedData(true);
    let dateSearch = false;
    if (searchData.invoiceStartDate !== "" && searchData.invoiceEndDate !== "")
      dateSearch = true;

    let doSearch = false;

    if (
      dateSearch ||
      (searchData.applicantName != null && searchData.applicantName !== "") ||
      searchData.reportType.report_id !== 0
    )
      doSearch = true;

    if (doSearch) {
      searchBody.current = {
        requestor_id: user.requestorid,
        invoice_start_date:
          dateSearch === true
            ? dateFormat(searchData.invoiceStartDate, "yyyy-mm-dd")
            : "",
        completion_end_date:
          dateSearch === true
            ? dateFormat(searchData.invoiceEndDate, "yyyy-mm-dd")
            : "",
        applicant_name: searchData.applicantName,
        report_id:
          searchData.reportType.report_id === 0
            ? ""
            : searchData.reportType.report_id + "",
        pageNo: "1",
        pageSize: "9",
        sortingField: sortingField,
        sortingOrder: sortingOrder
      };
    }

    if (pageCount === 1) await GetInvoiceData([]);
  };

  const handleSorting = (sorting) => {
    var sortingField = sorting.value;
    if(sortingField !== ""){
      let sort = sortingField.split(" ");
      setSortingField(sort[0]);
      setSortingOrder(sort[1]);
    }
    else{
      setSortingField("invoice_id");
      setSortingOrder("desc");
    }
  }

  return (
    <>
      <Container>
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title forms-page-title">
              <h2>Invoices</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter">
              <InvoiceFilter
                search={handleSearch}
                advSearch={handleAdvanceSearch}
                requestorid={user.requestorid}
                reportTypes={reportTypes}
                reportFilterChange={reportFilterChange}
                displayShort={true}
                shortFields={[
                  { text: "Order No ↑ ", value: "order_id asc" },
                  { text: "Order No ↓ ", value: "order_id desc"},
                  { text: "Invoice Date ↑", value: "invoice_date asc"},
                  { text: "Invoice Date ↓", value: "invoice_date desc"},
                  { text: "Applicant ↑", value: "order_applicant_name asc"},
                  { text: "Applicant ↓", value: "order_applicant_name desc"},
                  { text: "Report Type ↑", value: "report_name asc"},
                  { text: "Report Type ↓", value: "report_name desc"},
                  { text: "Amount ↑", value: "invoice_amount asc"},
                  { text: "Amount ↓", value: "invoice_amount desc"},  
                ]}
                sortOrder={handleSorting}
              />
            </div>
          </Col>
        </Row>
        <Row className="reports-card-row forms-cards">
          {invoiceData.map((item) => (
            <Col xl={4} lg={4} md={6} sm={12}>
              <div className="cards">
                <div className="cards-head">
                  <div className="cards-title h5">Order No: {item.orderId}</div>
                </div>
                <div className="cards-body">
                  <div className="cards-text">
                    <div className="cards-list-group">
                      <div className="cards-list-item">
                        <span>Invoice Date: </span>
                        {item.invoiceDate}
                      </div>
                      <div className="cards-list-item">
                        <span>Applicant: </span>
                        {item.applicantName}
                      </div>
                      <div className="cards-list-item">
                        <span>Report Type: </span>
                        {item.reportName}
                      </div>
                      <div className="cards-list-item">
                        <span>Amount: </span>
                        {item.invoiceAmount}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="reports-action-btn">
                  <button
                    className="cards-link"
                    onClick={() =>
                      window.open(
                        `/Invoice?customerid=${
                          user.customerid
                        }&invoiceid=${item.id}`,
                        "_blank"
                      )
                    }
                  >
                    View Invoice
                  </button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <div
          className={
            showLoadMore ? "text-center my-5" : "text-center my-5 hide-div"
          }
        >
            <button onClick={loadMoreData} className="btn-load-more">
              Load More...
            </button>
        </div>
      </Container>
    </>
  );
}
